module.exports = __webpack_public_path__ + "static/media/rgzn.5a74a732.png";